import React, {PureComponent as Component} from 'react'; 
import {MCbrowser} from "../../Context/browserContext";
import ShowPictursBox from "../../Plugins/Post/Controllers/ShowPictursBox";
import ShowProfile from "./ShowProfile";
import ShowInvertFriend from "../../Plugins/Friend/Controllers/ShowInvertFriend";
import ShowFollowingBox from "../../Plugins/Friend/Controllers/ShowFollowingBox";
import Message from "./Message";

class  Notifications extends Component{

    componentDidMount(){
        let page = this.context.page;
        this.context.page.pageTitle.setTitle("اطلاعیه ها");
        this.setState({loaded: true });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.context.page.pageBreadcrumbs.current != null) {
            this.context.page.pageBreadcrumbs.current.setCurrent("message");
            this.context.page.pageBreadcrumbs.current.show();
        }
    }


    render() {

        return (
            <>
                <div className="row">
                    <main className="col col-xl-6 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12">
                       <Message />
                    </main>
                    <aside className="col col-xl-3 order-xl-1 col-lg-6 order-lg-2 col-md-6 col-sm-6 col-12 side-sticky">
                        <ShowProfile  />
                        <ShowInvertFriend />
                    </aside>
                    <aside className="col col-xl-3 order-xl-3 col-lg-6 order-lg-3 col-md-6 col-sm-6 col-12 side-sticky">
                        <ShowFollowingBox />
                        <ShowPictursBox />
                    </aside>
                </div> 
            </>
        ); 
  }
}

Notifications.contextType = MCbrowser;

export default Notifications;
